<table
  fd-table
  fdCompact
  [noBorderX]="true"
  [noBorderY]="true"
  class="transparent-table"
>
  <thead
    fd-table-header
    class="table-header"
    [noBorderX]="true"
    [noBorderY]="true"
  >
    <tr fd-table-row class="table-row">
      <th fd-table-cell [noBorderX]="true" [noBorderY]="true">Key</th>
      <th fd-table-cell [noBorderX]="true" [noBorderY]="true">Value</th>
      <th
        fd-table-cell
        [noBorderX]="true"
        [noBorderY]="true"
        style="width: 1%"
      ></th>
    </tr>
  </thead>
  <tbody fd-table-body class="table-body" [noBorderX]="true" [noBorderY]="true">
    @for (label of labels; track label; let i = $index) {
      <tr fd-table-row class="labels-table-row">
        <td fd-table-cell [noBorderX]="true" [noBorderY]="true">
          <fd-form-input-message-group
            [triggers]="['mouseenter', 'mouseleave']"
          >
            <input
              fd-form-control
              fdCompact
              type="text"
              [(ngModel)]="label.key.name"
              (ngModelChange)="onKeyChange(labels, label)"
              name="key"
              class="label-key"
              [placeholder]="definition.key.placeholder"
              [state]="label.key.state"
              [disabled]="!isEnabled"
            />
            @if (label.key.state !== null) {
              <fd-form-message [type]="label.key.state">{{
                label.key.message
              }}</fd-form-message>
            }
          </fd-form-input-message-group>
        </td>
        <td fd-table-cell [noBorderX]="true" [noBorderY]="true">
          <fd-form-input-message-group
            [triggers]="['mouseenter', 'mouseleave']"
          >
            <input
              fd-form-control
              fdCompact
              type="text"
              [(ngModel)]="label.value.name"
              (ngModelChange)="onValueChange(labels, label)"
              name="value"
              class="label-value"
              [placeholder]="definition.value.placeholder"
              [state]="label.value.state"
              [disabled]="!isEnabled"
            />
            @if (label.value.state !== null) {
              <fd-form-message [type]="label.value.state">{{
                label.value.message
              }}</fd-form-message>
            }
          </fd-form-input-message-group>
        </td>
        <td
          fd-table-cell
          [noBorderX]="true"
          [noBorderY]="true"
          class="delete-btn-cell"
        >
          <button
            fd-button
            class="remove-label-button"
            buttonType="transparent"
            (click)="onDelete(i)"
            fdType="transparent"
            [title]="definition.removeButtonTooltip"
            [disabled]="!isEnabled"
          >
            <app-icon icon="trash" size="lg"></app-icon>
          </button>
        </td>
      </tr>
    }
  </tbody>
</table>
<div>
  <button
    fd-button
    class="add-label-button"
    type="button"
    [disabled]="isAddDisabled() || !isEnabled"
    [fdCompact]="true"
    fdType="emphasized"
    (click)="onAdd()"
    [title]="
      isAddDisabled() || !isEnabled
        ? definition.disabledAddButtonTooltip || definition.addButtonTooltip
        : definition.addButtonTooltip
    "
  >
    <app-icon icon="plus" size="lg"></app-icon>
  </button>
</div>
